import script from "./AllUsersContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllUsersContent.vue?vue&type=script&setup=true&lang=ts"

import "./AllUsersContent.vue?vue&type=style&index=0&id=5e874df6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e874df6"]])

export default __exports__